import useFetch from '@hooks/useFetch';
import { components, paths } from '@api/api';
import { useMemo } from 'react';
import { useFiltersContext } from '@core/FiltersContext';

const url: keyof paths = '/api/Search/GetItemsExtended';

type Response = components['schemas']['SearchExtendedResultModel'];
type Payload = components['schemas']['SearchExtendedFilterModel'];

export function useSeasonalBarChartData () {
    const { defaultFiltersPayload } = useFiltersContext();

    const payload = useMemo((): Payload => {
        return {
            searchFilter: {
                filter: {
                    ...defaultFiltersPayload,
                    conceptTypeIds: [1],
                    respondentTypes: [1],
                },
                page: {
                    perPage: 0,
                    currentPage: 1,
                },
            }
        };
    }, [defaultFiltersPayload]);

    const { isLoading, data } = useFetch<Response>({
        url,
        method: 'post',
        payload,
    });


    return {
        isLoading,
        data,
    };
}